/* Mindful Luxe — Scroll fade-in observer */
(function () {
  if (typeof IntersectionObserver === 'undefined') return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ml-visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  function init() {
    document.querySelectorAll('.ml-fade').forEach(function (el) {
      observer.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
